import Layout from '@/components/Layout';
import { CheckCircle } from 'lucide-react';

export default function AboutPage() {
  const courses = [
    "CPD (Continuing Professional Development) certificate in dry needling",
    "CPD certificate on the course \"putting the science of rehabilitation and exercise products into everyday practise\"",
    "The Assessment and treatment of adult with neurological conditions - The Bobath Concept",
    "Clinical Approach for the Treatment of Musculoskeletal Pain: Treating the cervical, thoracic and lumbar spine. Treating Hip knee and shoulder",
    "Kinesiology Taping hands-on course: including a look at other sports tapes for injuries treatment",
    "Basic Life Support, Seating Course and Botox Training"
  ];

  return (
    <Layout>
      {/* Hero Section - White Background */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-bold text-slate-800 mb-4 animate-fade-in" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Meet Bong
          </h1>
          <p className="text-lg text-slate-600 max-w-2xl">
            Learn more about the person behind BN Physiotherapy
          </p>
        </div>
      </section>

      {/* Bio Section - Turquoise Background */}
      <section className="py-16 bg-[#5ce1e6]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            {/* Photo - White Background */}
            <div className="lg:col-span-1 animate-fade-in">
              <div className="sticky top-24">
                <div className="rounded-2xl overflow-hidden shadow-xl bg-white p-4">
                  <img 
                    src="/images/About_pic.jpg" 
                    alt="Bongekile Ngcamphalala" 
                    className="w-full h-auto rounded-xl"
                    data-testid="about-bong-image"
                  />
                </div>
              </div>
            </div>

            {/* Bio Text */}
            <div className="lg:col-span-2 space-y-6 text-slate-800 leading-relaxed animate-fade-in animate-delay-200">
              <p className="text-lg">
                <span className="font-semibold text-slate-900">Bongekile "Bong" Ngcamphalala</span> is a passionate physiotherapist and the founder of BN Physiotherapy.
              </p>

              <p>
                She obtained her <span className="font-medium text-slate-900">Bachelor of Science in Physiotherapy (Honours) in 2015</span> from the University of Limpopo – Medunsa Campus. She then completed her community service at Rob Ferreira Hospital in Nelspruit. Following this, Bongekile joined Rita Henn and Partners (RHP) in Auckland Park, where she discovered her passion for neurological rehabilitation.
              </p>

              <p>
                During her time at RHP, she gained invaluable experience working in the polytrauma unit, acquired brain injury (ABI), stroke, spinal unit, and outpatient department. Bongekile dedicated three years to the neurological department and further enhanced her expertise by obtaining a <span className="font-medium text-slate-900">Bobath Certificate</span>, enabling her to provide specialised treatment for patients with neurological conditions.
              </p>

              <p>
                Throughout her career in rehabilitation hospitals, she has also worked in acute care settings, providing cardiothoracic pre- and post-operative treatments. In 2022, Bongekile established her own private practice, initially offering home-based physiotherapy services. In 2023, she expanded her practice by opening consulting rooms at Cedar Square, Fourways, located within KT Health and Wellness Medical Centre next to Virgin Active.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Courses Section - White Background */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-slate-800 mb-8 animate-fade-in" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Courses & Certifications
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {courses.map((course, index) => (
              <div 
                key={index} 
                className="flex items-start gap-3 p-4 bg-slate-50 rounded-xl shadow-sm border border-slate-100 animate-fade-in card-hover"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <CheckCircle className="w-5 h-5 text-[#0e7490] flex-shrink-0 mt-0.5" />
                <span className="text-slate-700">{course}</span>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}
